























import { Component, Vue } from "vue-property-decorator";
import { Console, Events } from "@/common/global.ts";

import BasePage from "@/common/base-page.ts";

import UICloseButton from "@/views/ui/CloseButton.vue";
import UIHeaderBasic from "@/views/ui/HeaderBasic.vue";
import UIFooter from "@/views/ui/Footer.vue";

@Component({
    components: {
        UICloseButton,
        UIHeaderBasic,
        UIFooter,
    },
})
export default class About extends BasePage {

    // Animation
    // -----------------------------------------------------------------

    /**
     * [AnimateOut description]
     *
     * @param {[type]} onComplete: any [description]
     */
    public AnimateOut(onComplete: any = null): void {
        super.AnimateOut();

        setTimeout(onComplete, 500);
    }

}
